// Donation configuration. Both Venmo and Stripe accept any amount —
// the donor picks at checkout. We don't publish dollar tiers on our side.

export const VENMO = {
  username: "John-Kahrhoff",
  profileUrl: "https://venmo.com/u/John-Kahrhoff",
} as const;

// Stripe Payment Link in "Customer chooses price" mode. The donor types
// whatever amount they want on Stripe's checkout page.
export const STRIPE_CUSTOM_URL = "https://donate.stripe.com/14A28rfKybZq5UO6VX2cg04";

// Flip to `true` once Stripe is in LIVE mode (bank verified, link
// confirmed working with real cards). When false the Stripe button is
// hidden so donors don't hit a "TEST MODE" page with their real card.
export const STRIPE_LIVE = true;
